import type {
	AnalysisBatchRes,
	DealstackAiWrittenOutcome,
	TransactionProvenanceRes,
} from '@dealstack/shared/lib/backendClient';
import {
	DATE_FORMATS,
	formatBEDateToUiWithFallback,
} from '@dealstack/shared/lib/format/dates/date';
import { categoryPath } from '../AnalysisWorkspace/workspacePaths.utils';
import type { ProvenanceLineView } from './useTransactionProvenanceController.types';

export const PROVENANCE_KEYS = {
	fromBatch: 'dealstack_ai.provenance.from_batch',
	confirmedBy: 'dealstack_ai.provenance.confirmed_by',
	documents: 'dealstack_ai.provenance.documents',
	untitledBatch: 'dealstack_ai.batch_list.untitled',
} as const;

const OUTCOME_KEYS: Record<DealstackAiWrittenOutcome, string> = {
	created: 'dealstack_ai.confirm.outcome.written.created',
	attached: 'dealstack_ai.confirm.outcome.written.attached',
	replaced: 'dealstack_ai.confirm.outcome.written.replaced',
};

export const toProvenanceLine = (
	dealId: string,
	provenance: TransactionProvenanceRes,
	batch: AnalysisBatchRes | undefined
): ProvenanceLineView => ({
	batchTitle: batch?.title ?? null,
	batchPath: categoryPath(dealId, provenance.batchId, 'documents'),
	outcomeKey: OUTCOME_KEYS[provenance.outcome],
	confirmedBy: provenance.confirmedBy.displayName,
	confirmedOn: formatBEDateToUiWithFallback(provenance.confirmedAt, DATE_FORMATS.UI),
	documentCount: provenance.documentIds.length,
});
